import React, {useEffect} from 'react';
import Page from "../Page";
import Search from "../common/Search";
import BarChart from "../common/BarChart";
import Revisions from "../common/Revisions";
import MainHeader from "./main/MainHeader";
import StatisticSearch from "./main/StatisticSearch";
import {AuthService} from "../../services/AuthService";

const Main = () => {
    return (
        <Page>
            <div className="mt-4 w-full inline-table" id="page-wrapper">
                <StatisticSearch />
                <MainHeader />
                <BarChart />
                <Revisions />
            </div>
        </Page>
    );
};

export default Main;